import ActionTypes from '../actions/actionTypes';

const initialState = {
  scheduledReportsListLoading: false,
  scheduledReportsListLoaded: false,
  scheduledReportsListError: false,
  scheduledReportsList: [],
  scheduledReportsListResultSize: 0,

  scheduledReportLoading: false,
  scheduledReportLoaded: false,
  scheduledReportError: false,
  scheduledReport: null,

  createScheduledReportLoading: false,
  createScheduledReportLoaded: false,
  createScheduledReportError: false,

  updateScheduledReportLoading: false,
  updateScheduledReportLoaded: false,
  updateScheduledReportError: false,

  deleteScheduledReportLoading: false,
  deleteScheduledReportLoaded: false,
  deleteScheduledReportError: false,

  enableScheduledReportLoading: false,
  enableScheduledReportLoaded: false,
  enableScheduledReportError: false,

  disableScheduledReportLoading: false,
  disableScheduledReportLoaded: false,
  disableScheduledReportError: false,

  reportsListLoading: false,
  reportsListLoaded: false,
  reportsListError: false,
  reportsList: [],
  reportsListResultSize: 0,

  downloadReportLoading: false,
  downloadReportLoaded: false,
  downloadReportError: false
};

export function reportsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.REPORTS.GET_SCHEDULED_REPORTS_LIST.REQUEST:
      return {
        ...state,
        scheduledReportsListLoading: true,
        scheduledReportsListLoaded: false,
        scheduledReportsListError: false
      };
    case ActionTypes.REPORTS.GET_SCHEDULED_REPORTS_LIST.SUCCESS:
      return {
        ...state,
        scheduledReportsListLoading: false,
        scheduledReportsListLoaded: true,
        scheduledReportsList: payload.scheduledReportsList,
        scheduledReportsListResultSize: payload.scheduledReportsListResultSize
      };
    case ActionTypes.REPORTS.GET_SCHEDULED_REPORTS_LIST.FAILURE:
      return {
        ...state,
        scheduledReportsListLoading: false,
        scheduledReportsListError: true,
        scheduledReportsList: [],
        scheduledReportsListResultSize: 0
      };
    case ActionTypes.REPORTS.GET_SCHEDULED_REPORTS_LIST.RESET:
      return {
        ...state,
        scheduledReportsListLoading: false,
        scheduledReportsListLoaded: false,
        scheduledReportsList: [],
        scheduledReportsListResultSize: 0
      };
    case ActionTypes.REPORTS.GET_SCHEDULED_REPORT.REQUEST:
      return {
        ...state,
        scheduledReport: null,
        scheduledReportLoading: true,
        scheduledReportLoaded: false,
        scheduledReportError: false
      };
    case ActionTypes.REPORTS.GET_SCHEDULED_REPORT.SUCCESS:
      return {
        ...state,
        scheduledReportLoading: false,
        scheduledReportLoaded: true,
        scheduledReport: payload.scheduledReport
      };
    case ActionTypes.REPORTS.GET_SCHEDULED_REPORT.FAILURE:
      return {
        ...state,
        scheduledReportLoading: false,
        scheduledReportError: true
      };
    case ActionTypes.REPORTS.CREATE_SCHEDULED_REPORT.REQUEST:
      return {
        ...state,
        createScheduledReportLoading: true,
        createScheduledReportLoaded: false,
        createScheduledReportError: false
      };
    case ActionTypes.REPORTS.CREATE_SCHEDULED_REPORT.SUCCESS:
      return {
        ...state,
        createScheduledReportLoading: false,
        createScheduledReportLoaded: true
      };
    case ActionTypes.REPORTS.CREATE_SCHEDULED_REPORT.FAILURE:
      return {
        ...state,
        createScheduledReportLoading: false,
        createScheduledReportError: true
      };
    case ActionTypes.REPORTS.CREATE_SCHEDULED_REPORT.RESET:
      return {
        ...state,
        createScheduledReportLoading: false,
        createScheduledReportLoaded: false,
        createScheduledReportError: false
      };
    case ActionTypes.REPORTS.UPDATE_SCHEDULED_REPORT.REQUEST:
      return {
        ...state,
        updateScheduledReportLoading: true,
        updateScheduledReportLoaded: false,
        updateScheduledReportError: false
      };
    case ActionTypes.REPORTS.UPDATE_SCHEDULED_REPORT.SUCCESS:
      return {
        ...state,
        updateScheduledReportLoading: false,
        updateScheduledReportLoaded: true
      };
    case ActionTypes.REPORTS.UPDATE_SCHEDULED_REPORT.FAILURE:
      return {
        ...state,
        updateScheduledReportLoading: false,
        updateScheduledReportError: true
      };
    case ActionTypes.REPORTS.UPDATE_SCHEDULED_REPORT.RESET:
      return {
        ...state,
        updateScheduledReportLoading: false,
        updateScheduledReportLoaded: false,
        updateScheduledReportError: false
      };
    case ActionTypes.REPORTS.DELETE_SCHEDULED_REPORT.REQUEST:
      return {
        ...state,
        deleteScheduledReportLoading: true,
        deleteScheduledReportLoaded: false,
        deleteScheduledReportError: false
      };
    case ActionTypes.REPORTS.DELETE_SCHEDULED_REPORT.SUCCESS:
      return {
        ...state,
        deleteScheduledReportLoading: false,
        deleteScheduledReportLoaded: true
      };
    case ActionTypes.REPORTS.DELETE_SCHEDULED_REPORT.FAILURE:
      return {
        ...state,
        deleteScheduledReportLoading: false,
        deleteScheduledReportError: true
      };
    case ActionTypes.REPORTS.DELETE_SCHEDULED_REPORT.RESET:
      return {
        ...state,
        deleteScheduledReportLoading: false,
        deleteScheduledReportLoaded: false,
        deleteScheduledReportError: false
      };
    case ActionTypes.REPORTS.ENABLE_SCHEDULED_REPORT.REQUEST:
      return {
        ...state,
        enableScheduledReportLoading: true,
        enableScheduledReportLoaded: false,
        enableScheduledReportError: false
      };
    case ActionTypes.REPORTS.ENABLE_SCHEDULED_REPORT.SUCCESS:
      return {
        ...state,
        enableScheduledReportLoading: false,
        enableScheduledReportLoaded: true
      };
    case ActionTypes.REPORTS.ENABLE_SCHEDULED_REPORT.FAILURE:
      return {
        ...state,
        enableScheduledReportLoading: false,
        enableScheduledReportError: true
      };
    case ActionTypes.REPORTS.ENABLE_SCHEDULED_REPORT.RESET:
      return {
        ...state,
        enableScheduledReportLoading: false,
        enableScheduledReportLoaded: false,
        enableScheduledReportError: false
      };
    case ActionTypes.REPORTS.DISABLE_SCHEDULED_REPORT.REQUEST:
      return {
        ...state,
        disableScheduledReportLoading: true,
        disableScheduledReportLoaded: false,
        disableScheduledReportError: false
      };
    case ActionTypes.REPORTS.DISABLE_SCHEDULED_REPORT.SUCCESS:
      return {
        ...state,
        disableScheduledReportLoading: false,
        disableScheduledReportLoaded: true
      };
    case ActionTypes.REPORTS.DISABLE_SCHEDULED_REPORT.FAILURE:
      return {
        ...state,
        disableScheduledReportLoading: false,
        disableScheduledReportError: true
      };
    case ActionTypes.REPORTS.DISABLE_SCHEDULED_REPORT.RESET:
      return {
        ...state,
        disableScheduledReportLoading: false,
        disableScheduledReportLoaded: false,
        disableScheduledReportError: false
      };
    case ActionTypes.REPORTS.GET_REPORTS_LIST.REQUEST:
      return {
        ...state,
        reportsListLoading: true,
        reportsListLoaded: false,
        reportsListError: false,
        reportsList: [],
        reportsListResultSize: 0,
      };
    case ActionTypes.REPORTS.GET_REPORTS_LIST.SUCCESS:
      return {
        ...state,
        reportsListLoading: false,
        reportsListLoaded: true,
        reportsList: payload.reportsList,
        reportsListResultSize: payload.reportsListResultSize,
      };
    case ActionTypes.REPORTS.GET_REPORTS_LIST.FAILURE:
      return {
        ...state,
        reportsListLoading: false,
        reportsListError: true,
        reportsList: [],
        reportsListResultSize: 0,
      };
    case ActionTypes.REPORTS.GET_REPORTS_LIST.RESET:
      return {
        ...state,
        reportsListLoading: false,
        reportsListLoaded: false,
        reportsList: [],
        reportsListResultSize: 0,
      };
    case ActionTypes.REPORTS.DOWNLOAD_REPORT.REQUEST:
      return {
        ...state,
        downloadReportLoading: true,
        downloadReportLoaded: false,
        downloadReportError: false
      };
    case ActionTypes.REPORTS.DOWNLOAD_REPORT.SUCCESS:
      return {
        ...state,
        downloadReportLoading: false,
        downloadReportLoaded: true
      };
    case ActionTypes.REPORTS.DOWNLOAD_REPORT.FAILURE:
      return {
        ...state,
        downloadReportLoading: false,
        downloadReportError: true
      };
    default:
      return state;
  }
}
